import { create } from "zustand";

export interface DepositData {
  depositAddress: string;
  amount: string;
  /**
   * Identifier sent to backend to check for deposit status
   */
  statusTrackingId: string;
  /**
   * Memo to be sent with the deposit transaction on-chain
   * Used by backend to track and index deposits
   */
  memo?: string;
}

export type PaymentMethod = "connectedWallet" | "depositAddress";

interface DepositAddressStore {
  deposit: DepositData | null;
  selectedPaymentMethod: PaymentMethod;
  setDeposit(data: DepositData | null): void;
  setPaymentMethod(method: PaymentMethod): void;
}

export const useDepositAddressStore = create<DepositAddressStore>((set) => ({
  deposit: null,
  selectedPaymentMethod: "connectedWallet",

  setDeposit: (data: DepositData | null) => {
    set({ deposit: data });
  },

  setPaymentMethod: (method: PaymentMethod) => {
    set({ selectedPaymentMethod: method });
  },
}));
